import { BinaryWriter } from '@neo-one/client-common';
import { ArrayContractParameter } from '@neo-one/node-core';
import { CircularReferenceError, InvalidValueBufferError } from './errors';
import { StackItemBase } from './StackItemBase';
export class ArrayLikeStackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    isArray() {
        return true;
    }
    asArray() {
        return this.value;
    }
    asBoolean() {
        return true;
    }
    asBuffer() {
        throw new InvalidValueBufferError();
    }
    toContractParameter(seen = new Set()) {
        if (seen.has(this)) {
            throw new CircularReferenceError();
        }
        const newSeen = new Set([...seen]);
        newSeen.add(this);
        return new ArrayContractParameter(this.value.map((val) => val.toContractParameter(newSeen)));
    }
    get size() {
        return this.value.length;
    }
    incrementInternal(seen) {
        return this.incrementInternalArray(this.value, seen);
    }
    decrementInternal(seen) {
        return this.decrementInternalArray(this.value, seen);
    }
    convertJSONInternal(seen) {
        return this.value.map((val) => val.convertJSON(seen));
    }
    serializeInternal(seen) {
        const writer = new BinaryWriter();
        writer.writeUInt8(this.constructor.type);
        writer.writeVarUIntLE(this.value.length);
        this.value.forEach((item) => {
            writer.writeBytes(item.serialize(seen));
        });
        return writer.toBuffer();
    }
}

//# sourceMappingURL=ArrayLikeStackItem.js.map
